import * as yup from "yup";
import { getValidationSchema } from "../../../../../shared/validations/schema";
export const customizeValidationSchema = (editStatus?: boolean) => {

  let defaultSchema: any = getValidationSchema([
    "name",
    "email",
    "gender",
    "phone",
    "roleID",
    ...(editStatus ? [] : ["password"]),
  ]);
  
  let customSchema = yup.object().shape({
    //add custom validation here
    
  });

  return defaultSchema.concat(customSchema);
};
